// extracted by mini-css-extract-plugin
export default {"dayNumber":"MonthView_dayNumber__FAcy+","wrapper":"MonthView_wrapper__3TOv4"};